import router from '../../router';

export const API_ENDPOINTS = {
  PROC_EXEC: 'proc:exec',
  UPDATE: 'update',
  INSERT: 'insert',
  DELETE: 'delete'
};

export const CONTENT_ENCODING_ENDPOINTS = [
  { api_url: 'event', ref_data: 'data_web' },
  { api_url: 'event', ref_data: 'data' },
  { api_url: 'property_log', ref_data: 'trend' },
  { api_url: 'property', ref_data: 'data' },
  { api_url: 'liquid_log', ref_data: 'yearmonth' },
  { api_url: 'facility', ref_data: 'ref' },
  { api_url: 'structure', ref_data: 'data' }
];

export class ErrorHandler {
  static handleAuthError(error) {
    if (error.response?.data?.status === 401 || (!error.response && error.request)) {
      localStorage.removeItem('token');
      router.push('/login?message=logout');
    }
    throw error;
  }

  static checkException(data) {
    const id = 'detailedMessage';
    if (data[id]) {
      throw data.detailedMessage;
    }
    return data;
  }
}
export class ParamsProcessor {
  constructor(prefix) {
    this.prefix = prefix;
  }

  prepareParams(params) {
    const processedParams = {};

    for (const [key, value] of Object.entries(params)) {
      const newKey = this.prefix + key;
      processedParams[newKey] = value;
    }

    return processedParams;
  }
}